export default __webpack_public_path__ + "static/media/successCheck.018936a8.svg";